<template>
    <div class="tournament-bracket__match" v-if="isLoading===false">
        <div class="bracket-match-box">
            <div class="bracket-match-info">
                <div class="bracket-match-info-left">
                    <div class="bracket-decoration-phase" v-if="match.round!==null">{{ match.round }}</div>
                </div>
                <div class="bracket-match-info-right">
                    {{ match.date_time_jogo | moment("DD MMM / HH:mm") }}
                </div>
            </div>

            <div class="bracket-match-team-vs">
                <div class="bracket-match-team-vs-item" v-bind:class="(match.teams_formatted.away.data.score > match.teams_formatted.home.data.score ? 'bracket-match-team-lost':'' )" v-if="match.teams_formatted.hasOwnProperty('home')">
                    <div class="bracket-team-info-wrap">
                      <img :src="$urlOrDefault(match.teams_formatted.home.team.logo_picture,'logo')" class="team-info-logo">{{ match.teams_formatted.home.data.name }}
                    </div>
                    <div class="bracket-team-score">
                        {{ match.teams_formatted.home.data.score }}
                    </div>
                </div>
                <div class="bracket-match-team-vs-item" v-bind:class="(match.teams_formatted.home.data.score > match.teams_formatted.away.data.score ? 'bracket-match-team-lost':'' )"  v-if="match.teams_formatted.hasOwnProperty('away')">
                    <div class="bracket-team-info-wrap">
                      <img :src="$urlOrDefault(match.teams_formatted.away.team.logo_picture,'logo')" class="team-info-logo">{{ match.teams_formatted.away.data.name }}
                    </div>
                    <div class="bracket-team-score">
                        {{ match.teams_formatted.away.data.score }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MatchRepository from "../../../api/MatchRepository";
    import Funcs from "@/functions";

    export default {
        name: "SingleGame",
        props:{
            matchId: Number,
            uidr: String,
        },
        data: function(){
            return {
                match:null,
                isLoading: true,
            }
        },
        created: function(){
            this.getData();
        },
        methods: {
            getData(){
                MatchRepository.getMatch(this.$props.matchId).then((response) => {
                    this.isLoading = false;
                    this.match=response.data;
                });

            },
            getImageUrl: function(url){
              return Funcs.getImageUrl(url);
            },
        },
    }
</script>

<style scoped>
    .bracket-match-box {
        width: 270px;
        height: 107.5px;
    }

    .bracket-match-info {
        width: 100%;
        height: 12px;
    }

    .bracket-match-info > .bracket-match-info-left {
        width: 40%;
        height: 100%;
        line-height: 12px;
        float: left;
        text-align: left;
    }

    .bracket-match-info > .bracket-match-info-right {
        width: 60%;
        height: 100%;
        float: right;
        text-align: right;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 12px;
        color: #78838A;
    }

    .bracket-decoration-phase {
        display: inline-block;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 9px;
        height: 12px;
        background: #AC8530;
        border-radius: 2px;
        color:#000;
        padding-left: 2%;
        padding-right: 2%;
    }

    .bracket-match-team-vs-item {
        width: 100%;
        height: 38px;
        background-color: #28333A;
    }

    .bracket-match-team-vs-item:first-child {
        margin-bottom: 1px;
        margin-top: 3px;
    }

    .bracket-team-info-wrap {
        width: 77%;
        height: 100%;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 38px;
        text-align: left;
        padding-left: 3%;
        color:#FFF;
        float: left;
    }

    .bracket-team-info-wrap > .team-info-logo {
        height: 60%;
        padding-right: 2%;
    }

    .bracket-team-score {
        width: 15%;
        float: right;
        text-align: center;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 13px;
        line-height: 38px;
        color:#FFF;
    }

    .bracket-match-team-lost {
        opacity: 0.5;
    }
</style>